import React from "react";

import { Avatar, AvatarProps } from "@strava/ui/Avatar";

export const AvatarWrapper = (props: AvatarProps) => {
  return <Avatar {...props} />;
};

export default AvatarWrapper;
